module.exports = __webpack_public_path__ + "img/1568456159.0797cc64.jpg";